import { Link } from 'react-router';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';

/** "← Parent" navigation at the top of detail pages — a ghost button, not a text link. */
export function BackLink({ to, children }: { to: string; children: React.ReactNode }) {
  return (
    <Button asChild variant="ghost" size="sm" className="-ml-2 text-muted-foreground hover:text-foreground">
      <Link to={to}>
        <ArrowLeft />
        {children}
      </Link>
    </Button>
  );
}
